import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import './ModemLights.scss';

const getOptionalMessage = (message) => {
  if (message) {
    return (<div className="">{message}</div>);
  }
  return null;
};

const ModemLights = (props) => {
  const { id, name, label, message } = props;
  return (
    <div>
      {getOptionalMessage(message)}
      <div>
        <Field
          name={name}
          component={(lights) => {
            const hasError = lights.meta.touched && lights.meta.error;
            return (
              <div className={`${hasError ? 'switch-error ' : ''}modem-lights`}>
                <div className={`${hasError ? 'switch-error ' : ''}modem-lights-label`}>{label}</div>
                <div className="switch-field">
                  <input
                    id={`${id}-off`}
                    type="radio" {...lights.input}
                    value="Off"
                    checked={lights.input.value === 'Off'}
                  />
                  <label htmlFor={`${id}-off`} id={`autotest-${id}-off`}>
                    <div className="modem-light-off" />
                    Off
                  </label>

                  <input
                    id={`${id}-flash`}
                    type="radio"
                    {...lights.input}
                    value="Flashing"
                    checked={lights.input.value === 'Flashing'}
                  />
                  <label htmlFor={`${id}-flash`} id={`autotest-${id}-flash`}>
                    <div className="modem-light-blink" />
                    Flashing
                  </label>

                  <input
                    id={`${id}-on`}
                    type="radio" {...lights.input}
                    value="On"
                    checked={lights.input.value === 'On'}
                  />
                  <label htmlFor={`${id}-on`} id={`autotest-${id}-on`}>
                    <div className="modem-light-on" />
                    On
                  </label>
                </div>
                {hasError &&
                <div className="switch-text-error">
                  {lights.meta.error}
                </div>
                }
              </div>
            );
          }
          }
        />
      </div>
    </div>
  );
};

ModemLights.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  message: PropTypes.string
};

export default ModemLights;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/ModemLights/ModemLights.js
 **/